module.exports = __webpack_public_path__ + "img/qdqmedia.372428dc.webp";